<template>
	<div
		class=""
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<carousel
			:perPage="slideToShow"
			:autoplay="autoplay"
			:navigationEnabled="true"
			:loop="true"
			>
			<slide
				v-for="(item, index) in carousels"
				:key="index">
				<!-- <img
					:src="getImageUrl(item)"
					class="img-fluid mx-auto d-block" :alt="`img-${index}`"
					loading="lazy"
				> -->
				<div id="carousel-item">
					<auto-image
						classes="img-fluid mx-auto d-block img-carousel"
						:path="getImageUrl(item)"
						:parentWidth.sync="parentWidth"
						:is-optimize="isOptimizeImages"
					/>
				</div>
			</slide>
		</carousel>

	</div>
</template>

<script>
import AutoImage from '@/components/funnels/pagebuilder/parts/AutoImage.vue';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import {
	getNodeStyle,
	getCurrentElementWidth,
	// eslint-disable-next-line
} from '@/lib/helper';

// eslint-disable-next-line
import Carousel from '@/components/funnels/pagebuilder/parts/carousel/Carousel.vue';
// eslint-disable-next-line
import Slide from '@/components/funnels/pagebuilder/parts/carousel/Slide.vue';

export default {
	name: 'NodeCarousel',
	props: ['node', 'onPreview', 'previewDevice', 'settings'],
	components: {
		NodeAction,
		Carousel,
		Slide,
		AutoImage,
	},
	data() {
		return {
			parentWidth: null,
		};
	},
	computed: {
		carousels() {
			let items = [];
			if (this.node && this.node.options && this.node.options.content) {
				items = this.node.options.content.filter(curr => curr.is_visible);
			}
			return items;
		},
		slideToShow() {
			let slideToShow = this.node && this.node.options && this.node.options.slideToShow
				? parseInt(this.node.options.slideToShow)
				: 3;
			if (this.previewDevice === 'mobile') {
				slideToShow = this.node && this.node.options && this.node.options.slideToShowMobile
					? parseInt(this.node.options.slideToShowMobile)
					: 3;
			}
			return slideToShow;
		},
		autoplay() {
			return this.node?.options?.autoplay;
		},
		isOptimizeImages() {
			// eslint-disable-next-line
			return this.settings?.optimize_images ?? false;
		},
	},
	mounted() {
		this.$nextTick(
			// eslint-disable-next-line
			function() {
				this.getElementWidth();
			},
		);
	},
	methods: {
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getImageUrl(item) {
			let imgUrl = 'https://place-hold.it/600x400';

			if (item && item.src) {
				imgUrl = item.src;
			}
			return imgUrl;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},

		getElementWidth() {
			const width = getCurrentElementWidth('#carousel-item');
			this.parentWidth = width || 0;
		},
	},
};
</script>

<style scoped></style>
